import basePath from "base_path";
import createReduxPromiseAction from "utils/create_redux_promise_action";
import ActionTypes, {TagActionTypes} from "../constants/action_types";
import {IssueOverrideTagId} from "common/types/issue_override_tag";
import {OrganisationId} from "common/types/organisation";

export type UpdateIssueOverrideTagAction = {
  type: TagActionTypes["ISSUE_OVERRIDE_TAG_UPDATE"]["SUCCESS"];
  payload: {id: IssueOverrideTagId; name: string};
};

export default function issueOverrideTagUpdate(requestor) {
  return createReduxPromiseAction(
    ActionTypes.ISSUE_OVERRIDE_TAG_UPDATE,
    (
      organisationId: OrganisationId,
      issueOverrideTagId: IssueOverrideTagId,
      name: string,
    ) =>
      requestor
        .patch(
          `${basePath}/organisation/${organisationId}/issue_override_tag/${issueOverrideTagId}`,
          {name},
          {
            withCredentials: true,
          },
        )
        .then(response => response.data),
  );
}
